import { DSDivider, DSTableCell, Translate } from '@deltasierra/components';
import React, { useRef, useState } from 'react';
import { BlockedTemplateContentBuildEmailPreviewFragment } from './__graphqlTypes/BlockedTemplateContentBuildEmailPreviewFragment';

function Label(props: { label: string }): JSX.Element {
    return <span style={{ fontWeight: 'bold' }}>{`${props.label}: `}</span>;
}
Label.displayName = 'Label';

type BlockedPreviewsContentCellProps = {
    row: BlockedTemplateContentBuildEmailPreviewFragment;
};

export function BlockedPreviewsContentCell({ row }: BlockedPreviewsContentCellProps): JSX.Element {
    const [isHovering, setIsHovering] = useState(false);
    const anchorRef = useRef<HTMLAnchorElement>(null);

    const getIframePosition = () => {
        if (!anchorRef.current) {
            return {};
        }
        const rect = anchorRef.current.getBoundingClientRect();
        return {
            left: rect.right + 8,
            top: rect.top,
        };
    };

    return (
        <DSTableCell>
            <Label label="Subject" />
            {row.subject}
            <DSDivider />
            <Label label="Email html" />
            <a
                href={row.emailUpload.signedUrl}
                ref={anchorRef}
                rel="noreferrer"
                target="_blank"
                onMouseEnter={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
            >
                <Translate keyId="COMMON.VIEW" />
            </a>
            {isHovering && (
                <div
                    style={{
                        ...getIframePosition(),
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                        minHeight: '400px',
                        minWidth: '600px',
                        position: 'fixed',
                        zIndex: 1000,
                    }}
                    onMouseEnter={() => setIsHovering(true)}
                    onMouseLeave={() => setIsHovering(false)}
                >
                    <iframe
                        src={row.emailUpload.signedUrl}
                        style={{
                            border: 'none',
                            borderRadius: '4px',
                            height: '400px',
                            width: '600px',
                        }}
                        title="Email Preview"
                    />
                </div>
            )}
        </DSTableCell>
    );
}
BlockedPreviewsContentCell.displayName = 'BlockedPreviewsContentCell';
